import React from 'react'

const BreakElement = () => {
  return <hr style={{ clear: `both` }} />
}

export default BreakElement
